import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { SocioFondeadorService } from '../../services/socio-fondeador.service';
import { FondeadoresService } from '../../services/fondeadores.service';
declare var $;

@Component({
  selector: 'app-aumentar-saldo-modal',
  templateUrl: './aumentar-saldo-modal.component.html',
  styleUrls: ['./aumentar-saldo-modal.component.scss']
})
export class AumentarSaldoModalComponent implements OnInit {

  public incremento_saldo : any = {};
  public socio : any = {};
  public errors:any = {};
  public isLoading: boolean = false;
  public fechaActual : string = "";
  public opcionValida: boolean = false;

  constructor(
    private datesHelper : DatesHelpersService,
    private helperService: HelpersService,
    public socioFondeadorService: SocioFondeadorService,
    private fondeadoresService: FondeadoresService,
    public dialogRef: MatDialogRef<AumentarSaldoModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.incremento_saldo = this.socioFondeadorService.esquemaAumentoSaldo();
    let defaultDates = this.datesHelper.getMonthDate();
    this.fechaActual = defaultDates.fechaFin;

    //Agregamos datos por default
    this.incremento_saldo.fecha_incremento_saldo = this.fechaActual;
    this.incremento_saldo.idSocio = this.data.idSocio;
    //  this.incremento_saldo.idSocio = this.data.inversiones.id;
    this.obtenerSocioId(this.data.idSocio);
    
  }

  public close(){
    this.dialogRef.close({aumento:false})
  }

  public aceptar(){
    
    //Validar
    this.errors = this.socioFondeadorService.validarAumentoSaldo(this.incremento_saldo);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    if(!this.isLoading){
      this.isLoading = true;
      this.registrarAumentoSaldo();
    }else{
      console.log("Esperando a que termine una acción");
    }
  }

  public registrarAumentoSaldo(){
    this.socioFondeadorService.registrarIncrementoSaldo(this.incremento_saldo).subscribe(
      (response)=>
      {
        const datosIncremento = response.json();

       if (datosIncremento.success) {
         this.helperService.notification('Incremento de saldo agregado', 'Se ha agreago exitosamente el incremento de saldo', 'success');
         this.dialogRef.close({ aumento: true });
         //setTimeout(() => {window.location.reload()},3000);
         this.isLoading = false;
       }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);
        this.showServicesErrors(error.json().content);
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public obtenerSocioId(id:number){
    this.isLoading = true;
    this.socioFondeadorService.getSocioEspecifico(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        
        if(jsonResult.content){
          this.socio = jsonResult.content;
          console.log("Socio ID: ", this.socio);
          //Asignamos idFondeador
          this.incremento_saldo.idFondeador = this.socio.idFondeador;
          console.log("Esquema saldo: ", this.incremento_saldo);
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public changeFormaPago(){
    if(this.incremento_saldo.forma_pago == "transferencia" || this.incremento_saldo.forma_pago == "tarjeta"){
      this.opcionValida = true;
    }else if(this.incremento_saldo.forma_pago == "cheque" || this.incremento_saldo.forma_pago == "efectivo"){
      this.opcionValida = false;
      this.incremento_saldo.banco = null;
      this.incremento_saldo.num_clabe_tarjeta = null;
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/modulo-vista/aumentar-saldo-modal/aumentar-saldo-modal.component.ts